import gql from "graphql-tag";

const DashboardAggregateManager = gql`
  query dashboardAggregateManager(
    $timeframe: DashboardTimeFrame!
    $structures: [String]
    $users: [String]
    $type: DashboardType!
  ) {
    dashboardAggregateManager(
      timeframe: $timeframe
      structures: $structures
      users: $users
      type: $type
    ) {
      numFeedbacks
      numRead
      numNotRead
      numThinkAbout
      thinkAboutOverTime {
        count
        date
      }
      numKeepGoing
      keepGoingOverTime {
        count
        date
      }
      numGeneric
      genericOverTime {
        count
        date
      }
      numGoal
      goalOverTime {
        count
        date
      }
      valorOverTime {
        count
        date
      }
      numRequests
      numCompiled
      numNotCompiled
      numTouchpoints
      numTouchpointsPending
      numTouchpointsEnded
      numValor
      numSkill
      skillOverTime {
        count
        date
      }
    }
  }
`;

export default DashboardAggregateManager;
